<template>
  <div>
    <el-dialog title="预览模版" :visible.sync="viewOpen">
      <template>
        <div>
          <fm-generate-form
              ref="generateForm"
              :data="newPreData"
              :isTeacher="false"
              :value="editData"
              :disable="isdisable"
          ></fm-generate-form>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>


export default {
  data() {
    return {
      viewOpen: false,
      // jsonData:{},
      editData: {},
    }
  },
  props: {
    preData: {
      type: Object,
      default: () => {
      }
    },
    dataData: {
      type: Object,
      default: () => {
      }
    },
    isdisable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newPreData() {
      const {content} = this.preData
      if (!content)
        return null;
      else
        return JSON.parse(content)
    },
  },
  methods: {
    changeVisible(visible = false) {
      this.viewOpen = visible
    }
  }
}
</script>
